import { useEventListener } from 'ahooks';
import { useFramework } from '@/framework';
import { getAdapter } from '../adapter';
import { TextEditDependency } from '../dependency';
import { useTextEditState } from '../states/text-edit-state';
import { type AbilityDependency } from '../types';

export const useClipboardEvent = (editAreaRef: React.RefObject<HTMLDivElement>) => {
    const framework = useFramework();

    const getEditingLayer = useTextEditState()((state) => state.getEditingLayer);

    const paste = (event: ClipboardEvent) => {
        event.preventDefault();
        event.stopPropagation();

        const editingLayer = getEditingLayer();
        if (!editingLayer) return;

        const adapter = getAdapter(editingLayer.layerType);
        if (!adapter) return;

        const data = framework.getInstance(TextEditDependency).getClipboardData(event);
        if (!data || !data.text) return;

        if (adapter.onPaste) adapter.onPaste(framework, editingLayer, data);
    };

    const copyOrCut = (event: ClipboardEvent) => {
        event.stopPropagation(); // 阻止透传到 document

        const editingLayer = getEditingLayer();
        if (!editingLayer) return;

        const adapter = getAdapter(editingLayer.layerType);
        if (!adapter) return;

        if (adapter.onCopyOrCut) adapter.onCopyOrCut(framework, editingLayer);
    };

    useEventListener('paste', paste, { target: editAreaRef });
    useEventListener('copy', copyOrCut, { target: editAreaRef });
    useEventListener('cut', copyOrCut, { target: editAreaRef });
};
